// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-question-mark';

export const Component = () => (
  <g fill='none' stroke='currentColor'>
    <g strokeLinecap='round' strokeLinejoin='round'>
      <path d='M1.031 12.719A4.784 4.784 0 0 1 7.69 8.322M5.813 6.875a2.922 2.922 0 1 0 0-5.844 2.922 2.922 0 0 0 0 5.844zm6.906 10.094a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5z' />
      <path d='M11.39 11.922a1.328 1.328 0 1 1 1.329 1.328' />
    </g>
    <path d='M12.719 15.375a.266.266 0 1 1 0-.531m0 .531a.266.266 0 0 0 0-.531' />
  </g>
);

export const viewBox = '0 0 18 18';
